module.exports = __webpack_public_path__ + "img/browse-vehicles-three-tabs-black.ce9bb399.png";